export const NumberFormatRuLocale = (count: number | string): string => {
	if (typeof count === 'string' && Number(count))
		return new Intl.NumberFormat('ru-RU').format(Number(count))
	if (count === undefined) return new Intl.NumberFormat('ru-RU').format(0)
	if (typeof count === 'number') return new Intl.NumberFormat('ru-RU').format(count)
}

export const compareFrontVersions = (prev: string, next: string): boolean => {
	const versionFromServer = next?.split('.')
	const currentVersion = prev?.split('.')
	if (versionFromServer?.length !== currentVersion?.length) return false

	for (let i = 0; i < versionFromServer?.length; i += 1) {
		if (Number.isNaN(+versionFromServer[i]) && Number.isNaN(+currentVersion[i])) return false
		if (+versionFromServer[i] > +currentVersion[i]) return true
	}
	return false
}

export const currencyNumber = (value: number, maximumFractionDigits?: number): string => {
	if (typeof value === 'number') {
		return new Intl.NumberFormat('ru-RU', {
			style: 'currency',
			currency: 'RUB',
			maximumFractionDigits,
		}).format(value)
	}
	return undefined
}

export enum DecimalRoundedType {
	ROUND = 'round', // округление по правилам математики
	TRUNC = 'trunc', // округление в меньшую сторону
}
type OptionsDecimalRounded = {
	digits?: number
	type?: DecimalRoundedType
}
const defaultOptionsDecimalRounded = {
	digits: 2,
	type: DecimalRoundedType.ROUND,
}
export const decimalRounded = (num: number, options?: OptionsDecimalRounded): number => {
	if (typeof num !== 'number') return undefined
	const type = options?.type || defaultOptionsDecimalRounded.type
	const digits = options?.digits ?? defaultOptionsDecimalRounded.digits
	return Number(`${Math[type](Number(`${num}e${digits}`))}e-${digits}`)
}

export const currencyStringToNumber = (value: string): number => {
	if (typeof value === 'string') {
		const valueToNumber = value.replace(',', '.').replace(/[^.\d]/g, '')
		return valueToNumber ? +valueToNumber : undefined
	}
	if (typeof value === 'number') return value
	return undefined
}

export const normalizeSum = (numStr: string): string => {
	if (numStr) {
		const cleanedStr = parseInt(numStr?.replaceAll(/\s/g, ''), 10)
		return Number.isNaN(cleanedStr) ? undefined : cleanedStr.toLocaleString('ru')
	}
	return undefined
}
